<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal fade show d-block"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <div class="modal-header" id="modalTitle">
                <slot name="header">
                  {{ $t("reception.legacy") + ' (' + medicalRecord.getUser.firstName + ' ' + medicalRecord.getUser.lastName + ')' }}
                </slot>
              </div>
              <section id="modalDescription">
                <div class="mt-1" v-if="msgText">
                  <b-alert show  fade :variant="msgVariant">
                    <div class="alert-body">
                      <span v-text="msgText" />
                    </div>
                  </b-alert>
                </div>
                <b-row>
                  <b-col cols="6" class="mt-1">
                    <div class="border rounded p-2">
                      <h4 class="mb-1">
                        {{ $t('general.selectFile') }}
                      </h4>
                      <span class="text-sm-h4 text-primary">{{$t("general.acceptableFiles",{items :  ['pdf','doc','docx'].join(', ')})}}</span>
                      <b-media
                          no-body
                          vertical-align="center"
                          class="flex-column flex-md-row mt-1"
                      >
                        <b-media-body>
                          <div class="d-inline-block">
                            <b-form-file
                                v-model="file"
                                :accept="'.docx,.doc,.pdf'"
                                :placeholder="$t('general.selectFile')"
                            />
                          </div>
                        </b-media-body>
                      </b-media>
                    </div>
                  </b-col>
                  <b-col cols="6" class="mt-1">
                    <div class="border rounded p-2">
                      <h4 class="mb-1">
                        {{ $t('general.uploadedFiles') }}
                      </h4>
                      <b-media
                          no-body
                          vertical-align="center"
                          class="flex-column flex-md-row"
                      >
                        <b-media-body>
                          <div class="d-inline-block">
                            <b-row v-if="legacyFile">
                              <button class="btn cursor-pointer  left-2 zindex-1" @click="download(legacyFile)">
                                <b-icon :icon="legacyFile.extension === '.docx' ?  'file-earmark-word' : 'file-ppt' " scale="3"
                                        variant="info"></b-icon>
                              </button>
                              <b-row>
                                <b-col cols="12">
                                  {{$t('general.size')}}: {{ ((legacyFile.size / 1024).toFixed(1) )}} {{$t('general.kb')}}
                                </b-col>
                                <b-col cols="12">
                                  <a href="javascript:void(0)" class="text-danger" @click="deleteLegacy">{{$t('general.delete')}}</a>
                                </b-col>
                              </b-row>
                            </b-row>
                          </div>
                        </b-media-body>
                      </b-media>
                    </div>

                  </b-col>
                </b-row>
              </section>
            </div>
            <div class="modal-footer">
              <b-row>
                <button
                    type="button"
                    class="btn btn-success mr-1 ml-1"
                    @click="uploadFile"
                    aria-label="Close modal"
                >
                  {{ $t('general.ok') }}
                </button>
                <button
                    type="button"
                    class="btn btn-info mr-1 ml-1"
                    @click="close"
                    aria-label="Close modal"
                >
                  {{ $t('general.close') }}
                </button>
              </b-row>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {BRow, BCol, BButton, BFormFile, BMediaBody, BMedia, BAlert} from 'bootstrap-vue'
import {mapGetters} from "vuex";

export default {
  name: "LegacyModal",
  data() {
    return {
      imageBase64: [],
      articleAdd: {},
      file: null,
      lastFiles : [],
      msgText :  null,
      msgVariant :  null,
    }
  },
  props: {
    user: {
      default: null
    },
  },
  components: {
    BCol,
    BButton,
    BRow,
    BFormFile,
    BMediaBody,
    BMedia,
    BAlert
  },
  computed:{
    ...mapGetters({
          medicalRecord: 'medicalRecord/femaleMedicalRecord',}),
    legacyFile: {
      set(value){
        this.$store.dispatch('medicalRecord/setLegacyFile', {
          key: 'legacyFileId',
          value: value,
          gender: 'female'
        })
      },
      get()
      {
        return this.$store.state.medicalRecord.female.legacyFileId
      }
    }

  },
  methods: {
    download (file) {
      const url = file.baseUrl + file.bucketName + '/' +
      file.destination.replace("./client/", "") +
      file.filename;
      window.open(url, '_blank').focus();
    },
    deleteLegacy (file) {
      let parent = this;
      parent.msgVariant = null;
      parent.msgText= null;
      this.$bvModal.msgBoxConfirm(this.$t('general.confirmDelete'), {
        title: this.$t('general.confirmDeleteTitle'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('general.yes'),
        cancelTitle: this.$t('general.no'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
            if (value === true) {
              this.$store.commit('SET_IS_LOADING', true)
              this.$store
                  .dispatch("legacyField/deleteMedicalRecordLegacy", {
                    userId: this.user,
                  })
                  .then((data) => {
                    parent.legacyFile = data.legacyFileId;
                    this.$store.commit('SET_IS_LOADING', false);
                    parent.msgVariant = 'success';
                    parent.msgText= this.$t('toastification.deletionSucceed');
                  })
                  .catch((error) => {
                    this.$store.commit('SET_IS_LOADING', false)
                    let msg = '';
                    switch (error.response.status) {
                      case 422:
                        msg = this.$t('toastification.deletionFailed');
                        break;

                      case 404:
                        msg = this.$t('toastification.deletionFailed');
                        break;

                      case 400:
                        msg = this.$t('toastification.badRequest');
                        break;
                    }


                    this.$bvToast.toast(msg, {
                      title: this.$t('toastification.error'),
                      variant: 'danger',
                      solid: true,
                    });
                  });


            }
          })
          .catch(err => {
            alert('error');
          })
    },
    close() {
      this.$emit('close');
    },
    uploadFile() {
      if (this.file) {
        this.$store.commit('SET_IS_LOADING', true);
        let formData = new FormData();
        formData.append('file', this.file);
        let parent = this;
        this.$store
            .dispatch("legacyField/createMedicalRecordLegacy", {
              userId: this.user,
              formData: formData,
            })
            .then((data) => {
              parent.legacyFile = data.legacyFileId;
              parent.msgVariant = 'success';
              parent.msgText= this.$t('toastification.submissionSucceed');
              this.$store.commit('SET_IS_LOADING', false);
            })
            .catch((error) => {
              this.$store.commit('SET_IS_LOADING', false)
              let msg = '';
              switch (error.response.status) {
                case 422:
                  msg = this.$t('toastification.duplicatedData');
                  break;

                case 400:
                  msg = this.$t('toastification.badRequest');
                  break;

                case 404:
                  msg = this.$t('toastification.notFound');
                  break;
              }

              parent.msgVariant = 'danger';
              parent.msgText= msg;
            });
      } else {
        this.msgVariant = 'warning';
        this.msgText= this.$t("toastification.fileNotSelected");
      }
    },
  },

}
</script>

<style scoped>
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 1 !important;
}


.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #4AAE9B;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4AAE9B;
  border: 1px solid #4AAE9B;
  border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease;
}
</style>